import { currentCopilotSession as e } from "../global-state.js";
import { CopilotSession as t } from "../session.js";
import { CopilotSessionRegistry as n } from "../registry.js";
import { atom as r } from "nanostores";
import { useCallback as i, useEffect as a, useRef as o, useState as s } from "react";
import { useStore as c } from "@nanostores/react";
// src/react/session.ts
var l = r(void 0), u = r(null);
function d(n) {
	let r = o(n?.config);
	r.current = n?.config;
	let [c, l] = s(() => new t(r.current)), u = i(() => {
		let e = new t(r.current);
		return l(e), e;
	}, []);
	return a(() => {
		n?.isPrimary && e.set(c);
	}, [c, n?.isPrimary]), a(() => () => {
		c.dispose();
	}, [c]), Object.assign(c, { reset: u });
}
function f() {
	let [t] = s(() => {
		let e = new n();
		return e.startNew(), e;
	}), r = c(t.__entries), i = c(t.__activeSession);
	if (i == null) throw Error("CopilotSessionRegistry invariant violated: no active session");
	return a(() => {
		e.get() !== i && e.set(i);
	}, [i]), a(() => () => {
		t.disposeAll();
	}, [t]), {
		registry: t,
		activeSession: i,
		entries: r
	};
}
function p() {
	return c(e);
}
function m(e) {
	return c(e?.__id ?? l);
}
function h(e) {
	return c(e?.__status ?? u);
}
function g(e) {
	return c(e.__statefulMessages);
}
function _(e) {
	return c(e.__tools);
}
function v(e) {
	return c(e.__meta);
}
function y(e) {
	return c(e.__queuedMessages);
}
function b(e) {
	return c(e.__restoredMessages);
}
function x(e) {
	return c(e.__lastTurnStopped);
}
function S(e) {
	return c(e.__enableWebSearch);
}
function C(e) {
	let t = c(e.__approvalMode);
	return c(e.__approvalModeAvailable) ? t : "ask";
}
function w(e) {
	return {
		model: c(e.__model),
		isLocked: c(e.__modelLocked)
	};
}
export { C as useCopilotApprovalMode, _ as useCopilotAvailableTools, x as useCopilotLastTurnStopped, g as useCopilotMessages, v as useCopilotMeta, w as useCopilotModel, y as useCopilotQueuedMessages, b as useCopilotRestoredMessages, d as useCopilotSession, m as useCopilotSessionId, f as useCopilotSessionRegistry, h as useCopilotStatus, S as useCopilotWebSearch, p as usePrimaryCopilotSession };
